const safeCSSLength = (length) => typeof length === "number" ? `${length}px` : length;
export {
  safeCSSLength as s
};
//# sourceMappingURL=css-cc8466bb.mjs.map
